module.exports = __webpack_public_path__ + "img/PL08980.0a67f4ef.png";